<template>
    <div class="contact-form-wrapper">
        <div class="contact-form-inner-wrapper">
            <div class="go-back-button mobile">
                <FontAwesomeIcon icon="chevron-left" @click="$emit('close')"></FontAwesomeIcon>
            </div>
            <template v-if="!success">
                <div class="input-wrapper">
                    <p>ФИО</p>
                    <div class="inner-input-wrapper" :class="{'input-error' : errorList.full_name}">
                        <input type="text" v-model="formData.full_name">
                    </div>
                    <p class="error-text" v-if="errorList.full_name" v-for="err in errorList.full_name">{{
                            err
                        }}</p>
                </div>
                <div class="input-wrapper">
                    <div class="label-wrapper">
                        <p :class="{'active': selectedField === 'phoneNumber'}"
                           @click="selectedField = 'phoneNumber'">Телефон</p>
                        <p :class="{'active': selectedField === 'email'}"
                           @click="selectedField = 'email'">Эл. Почта</p>
                    </div>
                    <div class="inner-input-wrapper phone-number" :class="{'input-error' : errorList.phone}"
                         v-if="selectedField === 'phoneNumber'">
                        <img alt="" src="../assets/images/Icon-awesome-phone-alt.svg"/>
                        <span>+7</span>
                        <img class="flag" alt="" src="../assets/images/flag.png"/>
                        <input-mask v-model="formData.phone" mask="999 99999999" placeholder="000-00000000"
                                    maskChar="_"></input-mask>
                    </div>
                    <p class="error-text" v-if="selectedField === 'phoneNumber' && errorList.phone"
                       v-for="err in errorList.phone">{{
                            err
                        }}</p>
                    <div class="inner-input-wrapper email" :class="{'input-error' : errorList.email}"
                         v-if="selectedField === 'email'">
                        <img alt="" src="../assets/images/Icon-ionic-md-mail.svg"/>
                        <input type="email" v-model="formData.email">
                    </div>
                    <p class="error-text" v-if="selectedField === 'email' && errorList.email"
                       v-for="err in errorList.email">{{ err }}</p>
                </div>
                <div class="input-wrapper">
                    <p>Сообщение</p>
                    <div class="inner-input-wrapper textarea" :class="{'input-error' : errorList.question}">
                        <textarea name="comment" v-model="formData.question"></textarea>
                    </div>
                    <p class="error-text" v-if="errorList.question" v-for="err in errorList.question">{{ err }}</p>
                </div>
                <div class="input-wrapper">
                    <div class="check-box-wrapper">
                        <label class="check-box-inner-wrapper">
                            <span>Нажимая на кнопку, вы даете
                            <a target="_blank" href="/static/files/Согласие.pdf">СОГЛАСИЕ</a>
                            на обработку своих персональных данных в соответствии с
                            <a target="_blank"
                               href="/static/files/Положение-об-организации-работы-с-персональными-данными-и-Правила-работы-с-обезличенными-персональными-данными-1.pdf">ПОЛОЖЕНИЕМ</a>.
                             </span>

                            <input type="checkbox" v-model="formData.consent" checked="checked">
                            <span class="checkmark"></span>
                        </label>
                        <p class="error-text" v-if="errorList.consent" v-for="err in errorList.consent">{{
                                err
                            }}</p>
                    </div>
                </div>
                <div class="button-wrapper desktop">
                    <button v-if="!mainError || !noErrors" @click="$emit('close')">Назад</button>
                    <p class="error-text" v-if="mainError && noErrors">{{ mainError }}</p>
                    <button :disabled="mainError && noErrors ? false : !formData.consent" class="active"
                            @click="submitForm">{{
                            mainError && noErrors ? 'Попробуйте еще раз' : 'Отправить'
                        }}
                    </button>
                </div>
                <div class="button-wrapper mobile">
                    <p class="error-text" v-if="mainError && noErrors">{{ mainError }}</p>
                    <button :disabled="mainError && noErrors ? false : !formData.consent" class="active"
                            @click="submitForm">{{
                            mainError && noErrors ? 'Попробуйте еще раз' : 'Отправить'
                        }}
                    </button>
                </div>
            </template>
            <template v-else>
                <div class="success-message">
                    <img src="../assets/images/check.svg" alt=""/>
                    <p>{{
                            formType === 'sendFeedback' ? 'Ваше сообщение отправлено. Спасибо за отзыв.' : 'Ваше сообщение отправлено. Спасибо за сообщение.'
                        }}</p>
                </div>
                <div class="button-wrapper mobile">
                    <button @click="$emit('close')" class="active">Назад</button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import InputMask from 'vue-input-mask';
import {ajax, apiUrls} from "@/store/urls";

export default {
    props: ['doctorSlug', 'formType'],
    components: {
        FontAwesomeIcon,
        InputMask
    },
    data() {
        return {
            formData: {
                full_name: '',
                email: '',
                phone: '',
                question: '',
                consent: false,
            },
            selectedField: 'phoneNumber',
            success: false,
            errorList: {},
            mainError: false,
        }
    },
    methods: {
        submitForm() {
            const url = this.formType === 'sendFeedback' ? apiUrls.sendFeedbackToDoctor(this.doctorSlug) : apiUrls.askQuestionToDoctor(this.doctorSlug)
            const emptyFormData = {
                full_name: '',
                email: '',
                phone: '',
                question: '',
                consent: false,
            };
            const requestData = {
                full_name: this.formData.full_name,
                question: this.formData.question,
            }
            if (this.selectedField === 'phoneNumber') {
                requestData.phone = `+7${this.formData.phone}`;
                requestData.email = '';
            } else {
                requestData.phone = '';
                requestData.email = this.formData.email;
            }
            ajax
                .post(url, requestData)
                .then(() => {
                    this.formData = {...emptyFormData};
                    this.errorList = {};
                    this.mainError = false;
                    this.success = true;
                })
                .catch(err => {
                    this.errorList = err.response.data;
                    this.mainError = 'Ваше сообщение не отправилась. Проблема связи.';
                })
        }
    },
    computed: {
        noErrors() {
            return JSON.stringify(this.errorList) === '{}';
        },
    },
}
</script>

<style scoped>

.contact-form-wrapper {
    max-width: 1000px;
    padding: 50px 20px;
    background-color: #FFF;
    min-width: 990px;
    cursor: default;
}

.contact-form-inner-wrapper {
    margin: 50px auto;
    width: 576px;
}

.input-wrapper {
    margin-bottom: 32px;
}

.label-wrapper {
    display: flex;
}

.input-wrapper > p, .label-wrapper > p {
    text-align: left;
    font: normal normal 600 20px/27px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #006687;
    margin-bottom: 24px;
}

.label-wrapper > p {
    margin-right: 32px;
    margin-bottom: 20px;
    border-bottom: 4px solid transparent;
    opacity: 0.8;
    cursor: pointer;
}

p.active {
    border-color: #006687;
    opacity: 1;
}

.inner-input-wrapper {
    position: relative;
    background: #FFFFFF 0 0 no-repeat padding-box;
    border: 1px solid #006687;
    border-radius: 8px;
    height: 64px;
}

.inner-input-wrapper.input-error {
    border-color: #CA3D3D;
}

.inner-input-wrapper > img {
    height: 20px;
    width: 20px;
    position: absolute;
    top: 20px;
    left: 16px;
}

.inner-input-wrapper > span {
    text-align: left;
    font: normal normal normal 16px/21px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #707070;
    position: absolute;
    top: 20px;
    left: 48px;
}

.inner-input-wrapper > .flag {
    width: 24px;
    height: 16px;
    position: absolute;
    top: 22px;
    left: 80px;
}

.inner-input-wrapper > input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 10px 15px;
    text-align: left;
    font: normal normal normal 16px/21px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #707070;
}


p.error-text {
    text-align: left;
    font: normal normal normal 16px/21px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #CA3D3D;
}

.inner-input-wrapper.phone-number > input {
    padding-left: 116px;
}

.inner-input-wrapper.email > input {
    padding-left: 52px;
}

.inner-input-wrapper.textarea {
    width: 576px;
    height: 220px;
}

.inner-input-wrapper > textarea {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 10px 15px;
    text-align: left;
    font: normal normal normal 16px/21px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #707070;
    resize: none;
}

.button-wrapper {
    display: flex;
    justify-content: space-between;
}

.button-wrapper > .error-text {
    position: unset;
    display: inline-block;
    width: 256px;
    height: 48px;
}


.button-wrapper > button {
    width: 256px;
    height: 48px;
    border: 1px solid #006687;
    border-radius: 8px;
    font: normal normal 600 14px/19px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #006687;
    text-transform: uppercase;
}

button.active {
    background: #006687 0 0 no-repeat padding-box;
    color: #FFFFFF;
}

.button-wrapper > button:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}

.mobile {
    display: none;
}

.go-back-button {
    width: 100%;
    height: 64px;
    background: #006687 0 0 no-repeat padding-box;
    position: absolute;
    top: 0;
    left: 0;
}


.go-back-button > svg {
    position: absolute;
    top: 14px;
    left: 6px;
    width: 29px;
    height: 36px;
    color: white;
    padding: 10px;
    cursor: pointer;
}

.success-message > img {
    width: 256px;
    height: 256px;
}

.success-message > p {
    text-align: center;
    font: normal normal normal 20px/27px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #707070;
    margin: 30px 0 60px;
}

.check-box-wrapper {
    text-align: left;
}

.check-box-wrapper span {
    text-align: left;
    font: normal normal normal 9px/11px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #707070;
}

.check-box-wrapper a {
    font: normal normal normal 9px/11px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #006687
}

.check-box-inner-wrapper {
    display: block;
    position: relative;
    padding-left: 24px;
}

.check-box-inner-wrapper input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    position: absolute;
    top: 6px;
    left: 0;
    height: 14px;
    width: 14px;
    background-color: #FFFFFF;
    border: 1px solid #006A81;
    border-radius: 2px;
}

.check-box-inner-wrapper:hover input ~ .checkmark {
    background-color: #ccc;
}

.check-box-inner-wrapper input:checked ~ .checkmark {
    background-color: #006A81;
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.check-box-inner-wrapper input:checked ~ .checkmark:after {
    display: block;
}

.check-box-inner-wrapper .checkmark:after {
    left: 3px;
    top: 1px;
    width: 4px;
    height: 6px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}

@media only screen and (max-width: 768px) {
    .contact-form-wrapper {
        min-width: unset;
        max-width: unset;
    }
}


@media only screen and (max-width: 630px) {
    .desktop {
        display: none;
    }

    .mobile {
        display: initial;
    }

    .button-wrapper.mobile {
        display: flex;
        flex-direction: column;
    }

    .contact-form-inner-wrapper {
        margin: 20px auto;
        width: 311px;
    }

    .inner-input-wrapper.textarea {
        width: 311px;
        height: 185px;
    }

    .button-wrapper > button {
        width: 311px;
        height: 48px;
    }

    .contact-form-wrapper {
        min-width: unset;
        max-width: unset;
        overflow-y: auto;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        padding-top: 70px;
    }

    .success-message {
        padding: 40px 0;
    }
}


@media only screen and (max-width: 350px) {

    .contact-form-inner-wrapper {
        margin: 20px auto;
        width: 100%;
    }

    .inner-input-wrapper.textarea {
        width: 100%;
        height: 185px;
    }

    .button-wrapper > button {
        width: 100%;
        height: 48px;
    }
}

</style>